// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { runningArrow16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-running-arrow': IconRunningArrow;
    }
}

/**
 * The icon component for the 'runningArrow' icon
 */
export class IconRunningArrow extends Icon {
    public constructor() {
        super(runningArrow16X16);
    }
}

registerIcon('icon-running-arrow', IconRunningArrow);
export const iconRunningArrowTag = 'nimble-icon-running-arrow';
